<div class="container">
  <div class="row">
    <div class="col">
      <h3>Empresas Bloqueadas</h3>
    </div>
  
    <div class="col-auto">
      <button class="btn btn-primary" type="button" (click)="baixarEmpresasBloqueadas()" placement="bottom"
           ngbTooltip="Exporta um arquivo CSV com as empresas bloqueadas." [disabled]="!checkCiencia">
        <i class="fa fa-file"></i> Download</button>
    </div>
  </div>

  <div class="row">
    <div class="col">
      <p class="text-danger">Atenção!</p>
      <p>
        Para operações do Peac-FGI estão bloqueadas contratações com CNPJs constantes da Lista Empresas Bloqueadas acessíveis no Portal por meio da modalidade FGI PEAC, na funcionalidade Exportação/Empresas Bloqueadas.
      </p>
      <p>
        Para operações do Peac-FGI Crédito Solidário RS estão bloqueadas contratações com CNPJs constantes da Lista Empresas Bloqueadas acessíveis no Portal por meio da modalidade FGI PEAC Crédito Solidário RS, na funcionalidade Exportação/Empresas Bloqueadas.
      </p>
      <p>
        Para operações do FGEnergia estão bloqueadas contratações com CNPJs constantes da Lista Empresas Bloqueadas acessíveis no Portal por meio da modalidade FGEnergia, na funcionalidade Exportação/Empresas Bloqueadas.
      </p>

      <p>A lista apresenta apenas os números-bases (8 dígitos) dos CNPJs que, no momento do download,
        encontram-se em pelo menos uma das seguintes situações:</p>
      <ul>
      <li>CNPJs impedidos de contratar novas operações no Peac-FGI ou no Peac-FGI Crédito Solidário RS, pois têm
        alguma situação impeditiva, tais como: honra paga com valor honrado a
        recuperar em alguma operação garantida pelo FGI PEAC ou FGI PEAC Crédito Solidário RS, ou indícios de
        descumprimento de cláusula de manutenção de níveis de empregabilidade no
        território nacional em operação contratada em 2020 no âmbito do Peac-FGI; ou</li>
      <li>CNPJs com perspectiva de ficarem impedidos de contratar novas
        operações no Peac-FGI ou no Peac-FGI Crédito Solidário RS  por terem uma ou mais solicitações de honra em
        processamento com perspectiva de pagamento de honra em breve, que pode
        ou não vir a ocorrer, a depender de validações previstas, ou mesmo
        possibilidade de cancelamento da solicitação de honra devido ao
        pagamento pelo tomador do crédito da dívida vencida, entre outros casos.</li>
    </ul>
    <p>Todos os CNPJs que contiverem o mesmo número-base (isto é, os mesmos 8 dígitos iniciais) estarão na mesma condição.
      Exemplo: O CNPJ 12345678/0001-01 estará impedido de contratar caso 12345678 conste na lista como impedido.</p>
  </div>
</div>

  <div class="bn-form-group">
    <label for="termosSolicitacaoArquivoArea">Termos e condições: </label>
    <textarea class="form-control" id="termosSolicitacaoArquivoArea" rows="10" disabled>
      Este arquivo possui informações protegidas por lei.

      O Agente Financeiro se comprometea manter o sigilo das informações acessadas, as quais devem ser utilizadas para o fim exclusivo de contratar operações com garantia do FGI PEAC ou do FGI PEAC Crédito Solidário RS.  
      
      Para prosseguir com a consulta, é necessário ter obtido o consentimento do Tomador de Crédito a ser analisado.
      
      A divulgação das informações por qualquer meio constitui violação da lei e dos normativos do FGI, sujeitando o Agente Financeiro às penalidades previstas na legislação e nos normativos do FGI, sem prejuízo da obrigação de ressarcimento pelos danos causados ao FGI e seu Administrador, bem como ao Tomador de Crédito.      
    </textarea>
  </div>
  <div class="form-check">
    <input type="checkbox" class="form-check-input" id="checkCiencia" [(ngModel)]="checkCiencia">
    <label class="form-check-label" for="checkCiencia">Possuo os poderes necessários conferidos pelo Agente Financeiro para acessar informações sigilosas, estou ciente e desejo continuar</label>
  </div>
</div>
